import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { withRouter } from 'react-router-dom'

import NewCompany from '../components/modals/NewCompany'
import ReferralSourcesService from '../services/ReferralSourcesService'

export default withRouter(({ match, history }) => {
  const { id } = match.params
  const [model, setModel] = useState(null)
  const [isLoading, setIsLoading] = useState(!!id)

  useEffect(() => {
    if (id) {
      ReferralSourcesService.get(id)
        .then(data => {
          setModel(data)
          setIsLoading(false)
        })
        .catch(err => {
          console.error(err)
          setIsLoading(false)
        })
    }
  }, [id])

  const handleSave = (model, isUpdate) => {
    if (isUpdate) {
      return ReferralSourcesService.update(model)
    } else {
      return ReferralSourcesService.create(model)
    }
  }

  const handleSaveSuccess = () => {
    history.push('/library/clients')
  }

  const handleClose = () => {
    history.push('/library/clients')
  }

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <div className="container mt-4">
      <Helmet title={id ? `Edit Client ${model?.name ? `- ${model.name}` : ''}` : 'Add Client'} />
      <NewCompany
        oldModel={model}
        onSave={handleSave}
        onSaveSuccess={handleSaveSuccess}
        onClose={handleClose}
        title="Client"
      />
    </div>
  )
})
